export default {
  upTo: 'up to {value}',
  kpi: 'KPI',
  restrictions: 'Restrictions',
  timeRestrictions: 'Time restrictions',
  allChannels: 'All Channels',
  fullPeriod: 'Full Period',
  spendIn: 'Spend in',
  and: 'and',
  unrestricted: 'Unrestricted',
  moreThan: 'More than',
  lessThan: 'Less than',
  between: 'Between',
  exactly: 'Exactly',
  mediaSpendCalendar: 'Media Spend Calendar ({unit})',
  kpiWeighting: 'KPI Weighting',
  kpiAutoBalance: 'Auto-Balance'
}
